import React, {useState} from 'react'
import Plate from "../../Plate";
import CalendarIcon from "../../../assets/icon/CalendarIcon";
import DropDown from "../../DropDown";
import DatePicker from "../../../components/DatePicker";
import { parseTaskDate, TaskDateValue } from '../../../utils/formatDate';

interface DatePickerProps {
    setEstimate: (estimate: Date) => void
    estimate: TaskDateValue
    onlyIcon?: boolean
    dropdownPosition?: 'left' | 'right' | 'side-right'
    formatDate?: (date: Date) => string
}

export default function TaskEstimatePicker({setEstimate, estimate, onlyIcon, dropdownPosition = 'left', formatDate}: DatePickerProps) {
    const [isOpenDropDown, setIsOpenDropDown] = useState(false);
    const parsedEstimate = parseTaskDate(estimate)

    const getDate = (date: Date) => {
        setEstimate(date)
        setIsOpenDropDown(false)
    }

    const defaultFormatDate = (date: Date) => {
        const d = new Date(date)
        const dd = String(d.getDate()).padStart(2, '0')
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const yy = String(d.getFullYear()).slice(-2)
        return `${dd}/${mm}/${yy}`
    }

    const formatter = formatDate || defaultFormatDate

    return (
        <DropDown
            isOpen={isOpenDropDown}
            setIsOpen={setIsOpenDropDown}
            position={dropdownPosition}
            btn={(isOpen: boolean) => onlyIcon ? (
                <CalendarIcon color={(isOpen || !!parsedEstimate) ? '#64617E' : undefined}/>
            ) : (
                <Plate title={!parsedEstimate ? "Сроки" : formatter(parsedEstimate)}
                       icon={<CalendarIcon color={(isOpen || !!parsedEstimate) ? '#64617E' : undefined}/>}
                       active={isOpen}
                       filled={!!parsedEstimate}/>
            )}>
            <DatePicker getDate={getDate} initialDate={parsedEstimate}/>
        </DropDown>
    )
}
